document.addEventListener('click', (e) => {
  const prev = e.target.closest('[data-prev]');
  const next = e.target.closest('[data-next]');
  if (!prev && !next) return;

  const root = e.target.closest('[data-slider]');
  const track = root?.querySelector('[data-track]');
  if (!track) return;

  const amount = track.clientWidth;
  track.scrollBy({ left: next ? amount : -amount, behavior: 'smooth' });
});
